import React, { useContext } from 'react'
import { MotorBikesContext } from '../../../../../contexts/motorBikesContext'
import Table from '../../../../../elements/TableComponent'

const History = () => {

    const { servicesCurrentVehicle = [] } = useContext(MotorBikesContext)

    return (
        <div className="tab-pane fade" id="nav-Historial" role="tabpanel" aria-labelledby="nav-Historial-tab">
            <div className="row justify-content-center mx-0 p-2">
                {
                    servicesCurrentVehicle.length > 0 ?
                        <Table columns={
                            <>
                                <th>Service</th>
                                <th>Fecha</th>
                                <th>Asunto</th>
                                <th>Sucursal</th>
                                <th>Kilometraje</th>
                            </>
                        }
                            id="docRelTalbe"
                        >
                            {
                                servicesCurrentVehicle.sort((a, b) => b.DocNum > a.DocNum ? 1 : a.DocNum > b.DocNum ? -1 : 0).map(d =>
                                    <tr key={d.DocNum}>
                                        <td title={d.ServiceCallID}>{d.ServiceCallID}</td>
                                        <td>{!!d.CreationDate ? new Date(d.CreationDate.replaceAll('-', '/')).toLocaleString('default', { day: '2-digit', month: '2-digit', year: 'numeric' }) : ''}</td>
                                        <td className="text-truncate" title={d.Subject ? d.Subject : ''}>{d.Subject}</td>
                                        <td className="text-truncate" title={d.AliasName ? d.AliasName : ''}>{d.AliasName === undefined ? 'No indica' : d.AliasName}</td>
                                        <td>{d.U_Kilometraje}</td>
                                    </tr>
                                )
                            }
                        </Table>
                        :
                        <p className="text-center">No existen Services para el vehículo</p>

                }
            </div>
        </div>
    )
}

export default React.memo(History)